import { authHeader } from '../../_helpers';
import axios from 'axios';

export const assessmentsService = {
    getAssessementsHandler,
    respondentsAssessmentHandler,
    onSubmitAssessmentHandler,
};
axios.defaults.headers.common = authHeader();

function getAssessementsHandler(data) {
    return axios.post(`/assessments/assessment/questions/based/on/instrument/`, data)
        .then(response => {
            return response;
        });
}

function respondentsAssessmentHandler(data,currentDashboardObj) {
    let token = localStorage.getItem('access_token')
    if(currentDashboardObj.respondent__id == undefined ) {
 
        return axios.post(`/assessments/user/assessment/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
    }
    else {
     
        return axios.post(`/assessments/user/respondent/assessment/?access_token=${token}`, data)
        .then(response => {
            return response;
        });  
    }
}

function onSubmitAssessmentHandler(data,currentDashboardObj) {
    if(currentDashboardObj.respondent__id === undefined ) {
        return axios.post(`/assessments/submit/user/assessments/`, data)
        .then(response => {
            return response;
        })
    }
    else {
        return axios.post(`/assessments/submit/user/respondence/assessments/`, data)
        .then(response => {
            return response;
        })
    }
}




// WEBPACK FOOTER //
// ./src/_services/assessments/assessments.service.js